<script lang="ts" setup>
import type { PreviewItemData } from '@autobid/strapi-integration/typescript/auction/carPreview'
import type {
  AuctionCar,
  BarometerCar,
  DetailsCarItemData,
} from '@autobid/ui/types/Car'
import { useAutobidAuth } from '@autobid/nuxt-auth/src/composables/useAutobidAuth'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'

interface Props {
  car: AuctionCar | BarometerCar | DetailsCarItemData | PreviewItemData
  size: 'dynamic' | 'big'
}

const props = defineProps<Props>()

const { isAuthed } = useAutobidAuth()
const {
  updateAuctionCar,
  updateSearchCar,
  updateBarometerCarData,
  updateDetailsCarData,
} = useUpdateCar()
function handleUpdateWatch(value: boolean) {
  updateAuctionCar(props.car.auctionId, props.car.id, (data) => {
    return {
      ...data,
      isWatcher: value,
    }
  })
  updateSearchCar(props.car.id, (data) => {
    return {
      ...data,
      isWatcher: value,
    }
  })
  updateBarometerCarData(props.car.auctionId, props.car.id, (data) => {
    return {
      ...data,
      isWatcher: value,
    }
  })
  updateDetailsCarData(props.car.id, (data) => {
    return {
      ...data,
      isWatcher: value,
    }
  })
}
</script>

<template>
  <template v-if="isAuthed">
    <ElementsCarWatch
      v-if="!car.hasBid && car.stage !== 'FINISHED'"
      :car-id="car.id"
      :watched="car.isWatcher"
      :size="size"
      v-bind="$attrs"
      @update="handleUpdateWatch"
    />
    <ElementsCarNote :car="car" :size="size" v-bind="$attrs" />
    <DynamicAuctionItemListCarActionsTransport
      v-if="car.stage !== 'FINISHED'"
      v-bind="$attrs"
      :size="size"
      :car="car"
    />
  </template>
</template>
